export interface LoginDto
{
    getMsisdn(): string;
    getPassword():string;
}

export class LoginDtoImpl implements LoginDto
{
    private msisdn: string;
    private password: string;

    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getPassword(): string 
    {
        return this.password;
    }
    setPassword(password: string)
    {
        this.password = password;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/login/logindto.tsx